import { useAuth0 } from '@auth0/auth0-react'
import { Drawer, List, Typography, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import SidebarLink, { SidebarLinkType } from './SidebarLink'

interface SidebarProps {

}

const Sidebar = (props: SidebarProps) => {
  const navigation = useNavigate()
  const currentLocation = useLocation()
  const theme = useTheme()

  const { logout } = useAuth0()

  const permissions = useAppSelector(state => state.user.permissions)

  return (
    <Drawer
      variant='permanent'
      anchor='left'
    >
      <Box sx={{
        padding: '16px',
        width: '260px'
      }}>
        {process.env.REACT_APP_ENVIRONMENT! === 'development' &&
          <img src='ecliptic-capital-logo-light-dev.svg' alt='Ecliptic Capital' />
        }
        {process.env.REACT_APP_ENVIRONMENT! === 'staging' &&
          <img src='ecliptic-capital-logo-light-staging.svg' alt='Ecliptic Capital' />
        }
        {process.env.REACT_APP_ENVIRONMENT! === 'production' &&
          <img src='ecliptic-nav-logo-light.svg' alt='Ecliptic Capital' />
        }
      </Box>
      <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems='left' sx={{
        height: '100%'
      }}>
        <Box>
          <Typography 
            variant='caption'
            color={theme.palette.info.main}
            sx={{
              marginTop: '36px',
              padding: '16px'
            }}
          >
            MENU
          </Typography>
          <List>
            <SidebarLink 
              variant={SidebarLinkType.HOME}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.FUNDS}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.PORTFOLIO}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.INVESTORS}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.MEMBERS}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.PARTNERS}  
              onClick={() => {
                
              }} 
              selected={false} />
            <SidebarLink 
              variant={SidebarLinkType.STARTUPS}  
              onClick={() => {
                navigation('/startups')
              }} 
              selected={currentLocation.pathname.includes('/startups') || currentLocation.pathname === '/'} />
            {permissions.indexOf('users:invite') !== -1 &&
              <SidebarLink 
              variant={SidebarLinkType.ADMIN}  
              onClick={() => {
                navigation('/admin')
              }} 
              selected={currentLocation.pathname.includes('/admin') }/>
            }
          </List>
        </Box>

        <Box>
          <Typography 
            variant='caption'
            color={theme.palette.info.main}
            sx={{
              marginTop: '36px',
              padding: '16px'
            }}
          >
            ACCOUNT
          </Typography>
          <List>
            <SidebarLink onClick={() => {
              navigation('/profile')
            }} variant={SidebarLinkType.SETTINGS} selected={currentLocation.pathname === '/profile'} />
            <SidebarLink onClick={() => {
              logout({ returnTo: window.location.origin })
            }} variant={SidebarLinkType.LOGOUT} selected={false} />
          </List>
        </Box>
      </Box>
    </Drawer>
  )
}

export default Sidebar
